import React from 'react';
import Footer from './Footer';
import '../css/layout.css';

const Layout = ({ children }) => {
  return (
    <div className="layout-container">
      <main className="layout-main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;